function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.67,82.21a4,4,0,0,0-4.59,3.29A77.34,77.34,0,0,1,100,149.36a4,4,0,0,0,.63,7.94,3.45,3.45,0,0,0,.64-.05A85.31,85.31,0,0,0,172,86.8,4,4,0,0,0,168.67,82.21Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.81,157.25a3.39,3.39,0,0,0,.64.05,4,4,0,0,0,.63-7.94A77.83,77.83,0,0,1,179.38,108a4,4,0,1,0-7.13,3.64A85.81,85.81,0,0,0,234.81,157.25Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.26,172.17a20.39,20.39,0,0,1-23.87,0,4,4,0,1,0-4.69,6.48,28.4,28.4,0,0,0,33.22.07,4,4,0,0,0-4.66-6.5Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.11,256.71c-30.5,0-77.53-44-77.53-102.37a77.53,77.53,0,1,1,155.06,0,106.7,106.7,0,0,1-2.42,22.49,4,4,0,1,0,7.82,1.69,114.65,114.65,0,0,0,2.6-24.18,85.53,85.53,0,1,0-171.06,0c0,27.74,10.23,55.3,28.82,77.6,17.1,20.52,38.3,32.77,56.71,32.77a4,4,0,0,0,0-8Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.78,172.17a20.39,20.39,0,0,1-23.87,0,4,4,0,0,0-4.69,6.48,28.41,28.41,0,0,0,33.23.07,4,4,0,0,0-4.67-6.5Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.39,293.55c-.61-5.1-6.27-50.2-16.1-62.44a4,4,0,0,0-1-.89l-27.84-17.41a6.22,6.22,0,0,0-5.24-.64l-11.92-14.92a11.71,11.71,0,0,0-19.24,1.39,11.73,11.73,0,0,0-17.88,14.45,11.6,11.6,0,0,0-3.74,2,11.74,11.74,0,0,0-1.78,16.5l6.65,8.21a11.74,11.74,0,0,0-.23,13.66l18.76,27c8.63,12.94,36.11,33.07,37.28,33.92a4,4,0,1,0,4.71-6.47c-.27-.2-27.49-20.12-35.38-31.94l-18.8-27.1a3.78,3.78,0,0,1-.66-2.1l14,17.31a4,4,0,1,0,6.22-5l-26.36-32.51a3.73,3.73,0,0,1,.57-5.24,3.73,3.73,0,0,1,5.24.57,3.91,3.91,0,0,0,.95.83L231.31,251a4,4,0,1,0,6.23-5l-28.88-36a3.73,3.73,0,1,1,5.87-4.61L220,212l23.33,29.26a4,4,0,1,0,6.26-5l-23.39-29.34a3.73,3.73,0,0,1,.57-5.24,3.63,3.63,0,0,1,2.74-.8,3.69,3.69,0,0,1,2.49,1.36l34.67,43.38a4,4,0,0,0,6.25-5l-11.88-14.86,17.35,10.85c6.94,9.65,12.46,44.89,14,57.88a4,4,0,0,0,4,3.53l.48,0A4,4,0,0,0,300.39,293.55Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.53,238c-19,0-35.75-6.4-43.82-16.7a4,4,0,1,1,6.29-4.94c6.49,8.29,21.22,13.64,37.53,13.64,1.94,0,3.9-.08,5.82-.23a4,4,0,0,1,.63,8C180.86,237.89,178.69,238,176.53,238Z",
    style: {
      fill: "#ef5051"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalCare);
export default __webpack_public_path__ + "static/media/personal-care.523ff11119eb6a6474fb68e624415dc8.svg";
export { ForwardRef as ReactComponent };